import './assets/font/iconfont.css';
import './assets/styles/index.scss';
import 'element-ui/lib/theme-chalk/display.css';
import 'lightgallery.js/dist/css/lightgallery.min.css'
import Vue from 'vue'
// 导入路由模块
import router from './router/index'

import { 
    Button, 
    Icon,
    Container,
    Header,
    Main,
    Footer,
    Row,
    Col,
    Menu,
    MenuItem,
    Tag,
    Tooltip,
   } from 'element-ui';


Vue.use(Button);
Vue.use(Icon);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Tag);
Vue.use(Tooltip);

const app = new Vue({
    el:'#root',
    router,
})

export default app


// WEBPACK FOOTER //
// ./src/main.js